import React, { Component } from 'react';
import moment from 'moment';
import cx from 'classnames/bind';
import { Example, Properties, SourceCode } from 'examples';
import DateTimeInput from './DateTimeInput';

class DateTimeInputExample extends Component {

  constructor() {
    super();
    this.state = {
      selected: moment()
    };
  }

  onChange = (date) => {
    this.setState({
      selected: date ? date.clone() : null
    });
  };

  onPropChange = e => {
    this.setState(e.target.value);
  };

  render() {
    return (
      <Example {...this.props}>
        <Properties defaultProps={DateTimeInput.defaultProps} onChange={this.onPropChange} propTypes={DateTimeInput.propTypes} propValues={this.state}/>
        <DateTimeInput {...this.state} className={cx('datetime-wrapper', this.state.className)} onChange={this.onChange} />
        <SourceCode language="javascript" title="The onChange callback">
          {
            '/* For the DateTimeInput view to be updated the onChange and selected prop must be implemented. Example: */\n' +
            '\n' +
            'constructor() {\n' +
            '  this.state = { selected: moment() }\n' +
            '}\n' +
            '\n' +
            'onChange(date) {\n' +
            '  // the date parameter is a moment object\n' +
            '  this.setState({ selected: date })\n' +
            '}\n' +
            '\n' +
            'render() {\n' +
            '  return (<DateTimeInput onChange={this.onChange.bind(this)} selected={this.state.selected}/>);\n' +
            '}'
          }
        </SourceCode>
        <SourceCode querySelector=".core-datetimeinput"/>
        <SourceCode language="javascript" title="Filtered and highlighted props">
          {
            '/* See http://momentjs.com/docs/#/query/ for more Moment JS queries methods */\n' +
            '\n' +
            '// Highlighted moments example\n' +
            'highlight(date) {\n' +
            ' return date.isBetween(moment(), moment().add(5, \'days\'));\n' +
            '}\n' +
            '\n' +
            '// Filtered moments example\n' +
            'isWeekday(date) {\n' +
            ' return date.day() !== 0 && date.day() !== 6;\n' +
            '}\n' +
            '\n' +
            'render() {\n' +
            '  return (<DateTimeInput onSelect={this.onSelect.bind(this)} selected={this.state.selected} filtered={this.isWeekday} highlighted={this.highlight}/>);\n' +
            '}'
          }
        </SourceCode>
      </Example>
    );
  }

}

DateTimeInputExample.tags = 'calendar';

export default DateTimeInputExample;
